import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from 'react';
const getServerSnapshot = (): boolean => false;

/**
 * Subscribes to a CSS media query via `useSyncExternalStore` -- the
 * React-blessed way to read + subscribe to state that lives outside React
 * (here, `window.matchMedia`) without syncing it through a `useEffect` +
 * `setState` pair (react-hooks/set-state-in-effect). Server snapshot is
 * `false`, matching the pre-hydration render where `window` doesn't exist.
 */
export function useMediaQuery(query) {
  const $ = _c(4);
  let t0;
  if ($[0] !== query) {
    t0 = onChange => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    };
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const subscribe = t0;
  let t1;
  if ($[2] !== query) {
    t1 = () => window.matchMedia(query).matches;
    $[2] = query;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getSnapshot = t1;
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}